import Alert from './src/main';

/* istanbul ignore next */
Alert.install = function(Vue) {
  Vue.component(Alert.name, Alert);
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/element/packages/alert/index.js